import { signupWelcomeInterstitial } from '@summer-health/shared/content/react';
import { InterstitialPage } from '@summer-health/ui/care-interstitial';
import Head from 'next/head';
import { siteDescription, siteTitle } from '../../utils/site-meta-copy';

export function WelcomePage(): JSX.Element {
  const variables = new Map([['hasLanguageSwitcher', 'true']]);

  return (
    <>
      <Head>
        <meta name="description" content={siteDescription} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:url" content="https://care.summerhealth.com" />
        <meta name="twitter:title" content={siteTitle} />
        <meta name="twitter:description" content={siteDescription} />
        <meta name="twitter:image" content="/site-icon-192x192.png" />
        <meta name="twitter:creator" content="@joinsummer" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={siteTitle} />
        <meta property="og:description" content={siteDescription} />
        <meta property="og:site_name" content={siteTitle} />
        <meta property="og:url" content="https://care.summerhealth.com" />
        <meta property="og:image" content="/site-icon-512x512.png" />
      </Head>
      <InterstitialPage
        content={signupWelcomeInterstitial}
        isLoading={false}
        variables={variables}
        navigateUrlOverride="/signup/invite"
      />
    </>
  );
}
